import React from "react";

const NoProject = () => {
  return (
    <svg
      width="148"
      height="148"
      viewBox="0 0 148 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="148" height="148" fill="#F6F8FA" />
      <path
        d="M22.966 46.7917C22.966 46.7917 16.9166 46.8122 16.9166 52.841C16.9166 46.8122 10.8672 46.7917 10.8672 46.7917C10.8672 46.7917 16.9166 46.771 16.9166 40.7422C16.9166 46.771 22.966 46.7917 22.966 46.7917Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M141.238 95.4167C141.238 95.4167 135.188 95.4372 135.188 101.466C135.188 95.4372 129.139 95.4167 129.139 95.4167C129.139 95.4167 135.188 95.396 135.188 89.3672C135.188 95.396 141.238 95.4167 141.238 95.4167Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="57.6328"
        y="28.6484"
        width="65.9744"
        height="83.7857"
        rx="3.02661"
        transform="rotate(15.9553 57.6328 28.6484)"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeMiterlimit="10"
      />
      <path
        d="M115.519 42.6801L96.4981 109.208C94.831 115.04 88.7567 118.413 82.9254 116.746L37.2946 103.7C33.2897 102.555 30.9745 98.3858 32.1195 94.3809L52.0857 24.5446C52.5492 22.9236 54.2375 21.986 55.8585 22.4494L113.423 38.9073C115.044 39.3707 115.982 41.0591 115.519 42.6801Z"
        fill="white"
        stroke="#868C98"
        strokeMiterlimit="10"
      />
      <path
        d="M82.9257 116.748L32.9587 102.439C29.5113 101.454 27.5136 97.8673 28.4992 94.4199C29.3737 91.361 32.3186 89.4419 35.3795 89.7536L35.588 89.7736L86.7752 95.2356C81.6752 94.8408 76.8426 98.0612 75.381 103.174C73.7138 109.005 77.0871 115.079 82.9257 116.748Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeMiterlimit="10"
      />
      <path
        d="M63.7002 37.4044L66.802 42.9464L61.063 46.1583C60.4778 46.4858 60.2689 47.2258 60.5965 47.811C60.924 48.3962 61.6639 48.6051 62.2491 48.2775L69.0477 44.4725C69.6329 44.145 69.8418 43.4051 69.5142 42.8199L65.8195 36.2182C65.492 35.633 64.752 35.4241 64.1668 35.7517C63.5816 36.0792 63.3727 36.8192 63.7002 37.4044Z"
        fill="#868C98"
      />
      <path
        d="M96.2002 44.7959L89.5986 48.4907C89.3195 48.6469 89.1099 48.9127 89.023 49.2204C88.9362 49.5281 88.9758 49.8643 89.132 50.1434L92.937 56.9419C93.2645 57.5271 94.0045 57.736 94.5897 57.4085C95.1749 57.0809 95.3838 56.341 95.0563 55.7558L91.8443 50.0169L97.3863 46.9152C97.9716 46.5877 98.1804 45.8477 97.8529 45.2626C97.5254 44.6774 96.7854 44.4684 96.2002 44.7959Z"
        fill="#868C98"
      />
      <path
        d="M66.7316 59.2309L83.4018 63.9373C84.0472 64.1195 84.7181 63.744 84.9003 63.0986C85.0825 62.4532 84.707 61.7823 84.0616 61.6001L67.3914 56.8937C66.746 56.7115 66.0751 57.087 65.8929 57.7324C65.7107 58.3778 66.0862 59.0487 66.7316 59.2309Z"
        fill="#868C98"
      />
      <rect
        x="74.3535"
        y="77.1133"
        width="3.65196"
        height="10.0615"
        rx="1.51331"
        transform="rotate(15.9553 74.3535 77.1133)"
        fill="#E2E4E9"
      />
      <rect
        x="86.1309"
        y="77.9961"
        width="3.65196"
        height="12.4496"
        rx="1.51331"
        transform="rotate(15.9553 86.1309 77.9961)"
        fill="#E2E4E9"
      />
      <rect
        x="81.3789"
        y="73.5781"
        width="3.65196"
        height="15.3903"
        rx="1.51331"
        transform="rotate(15.9553 81.3789 73.5781)"
        fill="#E2E4E9"
      />
      <rect
        x="90.9668"
        y="84.4219"
        width="3.65196"
        height="7.60192"
        rx="1.51331"
        transform="rotate(15.9553 90.9668 84.4219)"
        fill="#E2E4E9"
      />
      <circle
        cx="57.155"
        cy="75.2522"
        r="10.3301"
        transform="rotate(15.9553 57.155 75.2522)"
        fill="white"
        stroke="#868C98"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.6008 81.0412C49.7443 78.0953 52.8173 76.3602 55.9218 76.8897C54.4123 76.1036 53.6117 74.3403 54.0978 72.6403C54.6532 70.6976 56.6783 69.573 58.621 70.1284C60.5636 70.6838 61.6882 72.7089 61.1328 74.6516C60.6468 76.3517 59.0352 77.4252 57.3383 77.2946C60.2534 78.4861 61.9448 81.5832 61.3586 84.6881C59.2191 85.6422 56.745 85.8777 54.3165 85.1834C51.8882 84.4891 49.9126 82.9817 48.6008 81.0412Z"
        fill="#868C98"
      />
      <path
        d="M55.9218 76.8897L55.8378 77.3825C56.0805 77.4239 56.3172 77.2825 56.3957 77.0491C56.4743 76.8157 56.3712 76.5599 56.1528 76.4462L55.9218 76.8897ZM48.6008 81.0412L48.1347 80.8602C48.0754 81.0131 48.0948 81.1853 48.1866 81.3212L48.6008 81.0412ZM57.3383 77.2946L57.3766 76.7961C57.1311 76.7772 56.9084 76.9398 56.8517 77.1794C56.795 77.419 56.9212 77.6643 57.1491 77.7574L57.3383 77.2946ZM61.3586 84.6881L61.5622 85.1447C61.712 85.078 61.8195 84.942 61.8499 84.7809L61.3586 84.6881ZM56.0059 76.3968C52.6675 75.8274 49.3643 77.6925 48.1347 80.8602L49.0669 81.2221C50.1243 78.4982 52.967 76.8929 55.8378 77.3825L56.0059 76.3968ZM53.617 72.5028C53.0644 74.4358 53.9749 76.4395 55.6909 77.3331L56.1528 76.4462C54.8497 75.7676 54.159 74.2449 54.5785 72.7777L53.617 72.5028ZM58.7584 69.6476C56.5502 69.0163 54.2484 70.2946 53.617 72.5028L54.5785 72.7777C55.058 71.1005 56.8063 70.1296 58.4835 70.6091L58.7584 69.6476ZM61.6136 74.789C62.2449 72.5808 60.9666 70.279 58.7584 69.6476L58.4835 70.6091C60.1607 71.0886 61.1316 72.837 60.6521 74.5141L61.6136 74.789ZM57.2999 77.7931C59.2289 77.9416 61.0609 76.722 61.6136 74.789L60.6521 74.5141C60.2326 75.9813 58.8414 76.9088 57.3766 76.7961L57.2999 77.7931ZM61.8499 84.7809C62.4803 81.4421 60.6621 78.113 57.5274 76.8318L57.1491 77.7574C59.8447 78.8592 61.4094 81.7243 60.8673 84.5953L61.8499 84.7809ZM61.155 84.2314C59.1188 85.1395 56.7653 85.3634 54.4539 84.7026L54.179 85.6641C56.7247 86.3919 59.3195 86.1449 61.5622 85.1447L61.155 84.2314ZM54.4539 84.7026C52.1428 84.0419 50.2635 82.6079 49.0151 80.7611L48.1866 81.3212C49.5617 83.3554 51.6336 84.9364 54.179 85.6641L54.4539 84.7026Z"
        fill="#868C98"
      />
      <path
        d="M108.866 52.1881L105.64 46.7403L100.023 49.6599L103.877 36.1797L112.72 38.7079L108.866 52.1881Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoProject;
